import { z } from "zod";

import { useForm, UseFormReturn } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { TestimonyFormData } from "../../testimony/entities/Testimony";
import {
  commentValidation,
  descriptionValidation,
  idValidation,
  imageValidation,
  listValidation,
  textValidation,
  titleValidation,
  urlValidation,
} from "../../../utils/validation";
import { TranslationFunction } from "../../../utils/utils";

export const useTestimonyFormValidation = (
  data: TestimonyFormData | null,
  t: TranslationFunction
): UseFormReturn<TestimonyFormData> => {
  const schema = z.object({
    title: titleValidation(t),
    subtitle: titleValidation(t),
    description: descriptionValidation(t),
    trainingId: idValidation(),
    image: imageValidation(),
    videoLink: urlValidation(t),
    text: textValidation(t),
    status: z.enum(["draft", "available", "unavailable"], {
      errorMap: () => ({ message: t("validation.required") }),
    }),
    tags: listValidation(t),
    keywords: listValidation(t),
    comments: commentValidation(),
  });

  const form = useForm<TestimonyFormData>({
    resolver: zodResolver(schema),
    defaultValues: data ?? {},
  });

  useEffect(() => {
    form.reset({ ...data });
  }, [data, form]);

  return form;
};
